export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 8_05.bf458f15.jpg";